export default __webpack_public_path__ + "static/media/drawer-plan.920d7843.svg";